var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPicture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "picture_1_",
    "data-name": "picture (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.6,
    height: 17.6,
    viewBox: "0 0 17.6 17.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3763",
    "data-name": "Path 3763",
    d: "M13.933,0H3.667A3.671,3.671,0,0,0,0,3.667V13.933A3.671,3.671,0,0,0,3.667,17.6H13.933A3.671,3.671,0,0,0,17.6,13.933V3.667A3.671,3.671,0,0,0,13.933,0ZM3.667,1.467H13.933a2.2,2.2,0,0,1,2.2,2.2V13.933a2.164,2.164,0,0,1-.22.942L9.194,8.156a3.667,3.667,0,0,0-5.186,0L1.467,10.7V3.667a2.2,2.2,0,0,1,2.2-2.2Zm0,14.666a2.2,2.2,0,0,1-2.2-2.2V12.77L5.044,9.193a2.2,2.2,0,0,1,3.112,0l6.719,6.72a2.164,2.164,0,0,1-.942.22Z",
    fill: "#c8102e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3764",
    "data-name": "Path 3764",
    d: "M15.067,8.633A2.567,2.567,0,1,0,12.5,6.067,2.567,2.567,0,0,0,15.067,8.633Zm0-3.667a1.1,1.1,0,1,1-1.1,1.1A1.1,1.1,0,0,1,15.067,4.967Z",
    transform: "translate(-3.334 -0.933)",
    fill: "#c8102e"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.8812be7f6b30049599dc51c93255676f.svg";
export { ForwardRef as ReactComponent };